import { Toaster, toast as sonnerToast } from "sonner"
import Panel from "../panel"

export interface HeadlessToastArgs {
  title: string
  description?: string
  action?: {
    label: string
    onClick?: () => void
  }
  duration?: number
}

export function showToast({ title, description, action, duration }: HeadlessToastArgs) {
  return sonnerToast.custom(
    (id) => (
      <HeadlessToast
        id={id}
        title={title}
        description={description}
        action={action}
      />
    ),
    {
      duration,
    },
  )
}

interface HeadlessToastProps extends HeadlessToastArgs {
  id: string | number
}

function HeadlessToast({ id, title, description, action }: HeadlessToastProps) {
  return (
    <Panel>
        <div className="flex gap-3 p-4 bg-card rounded-lg border-border">
          <div className="flex flex-col gap-1">
            <p className="text-sm font-medium">{title}</p>
            {description ? (
              <p className="text-sm">{description}</p>
            ) : null}
          </div>

          {action ? (
            <div className="flex items-center shrink-0">
              <button
                type="button"
                onClick={() => {
                  action.onClick?.()
                  sonnerToast.dismiss(id)
                }}
                className="rounded-md bg-brand-primary px-3 py-1.5 text-sm font-medium text-brand-primary-foreground shadow-sm transition-colors hover:bg-brand-primary/80"
                >
                {action.label}
              </button>
            </div>
          ) : null}
        </div>
    </Panel>
  )
}

export function SonnerHost() {
  return (
    <Toaster
      position="top-center"
      expand
      richColors={false}
      closeButton={false}
    />
  )
}
